import { IModalDescription } from '@cp/shared/modal';
import type { NotificationsSubscribeModalProps } from '../ui/subscribeModal';

export const SUBSCRIBE_MODAL: IModalDescription<NotificationsSubscribeModalProps> = {
  nss: 'notifications/subscribe',
  loader: () => import('../ui/subscribeModal').then((m) => m.NotificationsSubscribeModal),
};
